// Step registry and routing.
//   n        numeric id sent to analytics / Meta (keeps funnel order stable)
//   name     human label for the analytics dashboard
//   progress percentage shown in the progress bar

export const STEPS = {
  energy: { n: 1, name: "Tipo de energía", progress: 6 },
  housing: { n: 2, name: "Tipo de vivienda", progress: 12 },
  knowsKwh: { n: 3, name: "Conocimiento de consumo", progress: 18 },
  kwh: { n: 31, name: "Consumo anual kWh", progress: 25 },
  power: { n: 32, name: "Potencia contratada", progress: 32 },
  estimate: { n: 33, name: "Estimación rápida", progress: 25 },
  sqm: { n: 34, name: "Metros cuadrados", progress: 32 },
  people: { n: 35, name: "Personas en casa", progress: 40 },
  bill: { n: 4, name: "Factura mensual", progress: 48 },
  postal: { n: 5, name: "Código postal", progress: 56 },
  provider: { n: 6, name: "Proveedor de energía", progress: 64 },
  ineligible: { n: 61, name: "No elegible (ya es cliente Repsol)", progress: 64 },
  birth: { n: 7, name: "Año de nacimiento", progress: 72 },
  goodNews: { n: 8, name: "Buenas noticias", progress: 78 },
  email: { n: 9, name: "Email", progress: 85 },
  phone: { n: 10, name: "Teléfono", progress: 90 },
  name: { n: 11, name: "Nombre", progress: 95 },
  consent: { n: 12, name: "Aceptación final", progress: 100 },
  thanks: { n: 14, name: "Gracias", progress: 100 },
};

// Which step comes after `step`, given the value just chosen/entered.
export const nextAfter = (step, value) => {
  switch (step) {
    case "energy":
      return "housing";
    case "housing":
      return "knowsKwh";
    case "knowsKwh":
      return value === "Si" ? "kwh" : "estimate";
    case "kwh":
      return "power";
    case "power":
      return "bill";
    case "estimate":
      return "sqm";
    case "sqm":
      return "people";
    case "people":
      return "bill";
    case "bill":
      return "postal";
    case "postal":
      return "provider";
    case "provider":
      // Existing Repsol customers can't take the offer.
      return value === "Repsol" ? "ineligible" : "birth";
    case "birth":
      return "goodNews";
    case "goodNews":
      return "email";
    case "email":
      return "phone";
    case "phone":
      return "name";
    case "name":
      return "consent";
    default:
      return null;
  }
};
